export const SCHEDULE_ROW_HEIGHT = 39;
export const SCHEDULE_GANTT_HEADER_HEIGHT = 40;
export const SCHEDULE_DATE_LOCALE = "en-US";
